import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { categoryLabel, parseFailureReason } from "./failureReason";
import { Panel } from "./parts";
import { BTN } from "./ui";

/** Why the job stopped: failure category and the error ID to quote. */
export function FailurePanel({ reason }: { reason: string }) {
  const [copied, setCopied] = useState(false);
  const failure = parseFailureReason(reason);
  if (!failure) return null;

  const toCopy = failure.errorId ?? failure.raw;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(toCopy);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Panel title="Why it stopped">
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 text-sm">
        {failure.category ? (
          <>
            <dt className="text-ink-3">Category</dt>
            <dd className="text-ink-1">{categoryLabel(failure.category)}</dd>
            <dt className="text-ink-3">Error class</dt>
            <dd className="font-mono text-xs text-ink-1">{failure.exceptionClass}</dd>
            <dt className="text-ink-3">Error ID</dt>
            <dd className="font-mono text-xs text-ink-1">{failure.errorId}</dd>
          </>
        ) : (
          <>
            <dt className="text-ink-3">Reason</dt>
            <dd className="break-all font-mono text-xs text-ink-1">{failure.raw}</dd>
          </>
        )}
      </dl>
      <div className="mt-3 flex items-center gap-3">
        <button type="button" onClick={copy} className={BTN}>
          {copied ? <Check size={12} aria-hidden /> : <Copy size={12} aria-hidden />}
          {failure.errorId ? "Copy error ID" : "Copy reason"}
        </button>
        <span role="status" className="text-xs text-ink-3">
          {copied ? "Copied." : ""}
        </span>
      </div>
      {failure.errorId && (
        <p className="mt-3 text-xs text-ink-3">
          The runner log line with this error ID has the code location. No error text is stored
          with the job.
        </p>
      )}
    </Panel>
  );
}
